import { createInjectionKey } from "../../_utils/index.mjs";
export const loadingBarProviderInjectionKey = createInjectionKey('n-loading-bar');
export const loadingBarApiInjectionKey = createInjectionKey('n-loading-bar-api');